/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-24 18:59:18
 */
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { NzMessageService } from 'ng-zorro-antd';

import { I18NService } from '@ithinkdt/shared/i18n';

import { ResetPwdService } from './../../shared/fetch/service/reset-pwd.service';

@Component({
  selector: 'dt-reset-pwd',
  templateUrl: './reset-pwd.component.html',
})
export class ResetPwdComponent implements OnInit {
  @Input() formData: FormData;
  // è¡¨å
  form: FormGroup;
  // æ¯å¦æ¾ç¤ºæ¨¡ææ¡
  visible = false;
  // æ¯å¦æäº¤ç¶æ
  isSubmiting = false;

  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private ResetPwdSrv: ResetPwdService,
    private i18n: I18NService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      password: [null],
      newPassword: [null],
      confirmPassword: [null, [Validators.required, this.confirmationValidator]],
    });
  }

  // æå¼å¯¹è¯æ¡
  open() {
    this.visible = true;
  }

  // å³é­
  close() {
    this.visible = false;
    this.form.reset();
    this.form.enable();
  }

  // æäº¤/ç¡®è®¤æ°æ®
  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.valid) {
      this.ResetPwdSrv.updatePassword(this.form.value).subscribe((res) => {
        if (res.status) {
          this.handlerSucc(this.i18n.interpret('userManagement.changePasswordSuccess'));
        }
        this.isSubmiting = false;
      });
      this.close();
    }
  }

  // ä¿å­æèç¼è¾æåçä¿¡æ¯
  handlerSucc(title: string) {
    this.message.success(title);
  }

  // æ£æ¥æ¯å¦è¾å¥æ°å¯ç 
  updateConfirmValidator() {
    Promise.resolve().then(() => this.form.controls.confirmPassword.updateValueAndValidity());
  }

  // æ°å¯ç ä¸ç¡®è®¤å¯ç çå¤æ­ã
  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.form.controls.newPassword.value) {
      return { confirm: true, error: true };
    }
  };
}
